import React, { useState } from 'react';

const Footer: React.FC = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Aquí se manejaría la suscripción al newsletter
    alert('¡Gracias por suscribirte a nuestro newsletter!');
    setNewsletterEmail('');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      {/* Patrón decorativo de fondo */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-20 text-4xl">🐕</div>
        <div className="absolute top-32 right-32 text-3xl">🐱</div>
        <div className="absolute bottom-20 left-1/4 text-4xl">🐾</div>
        <div className="absolute bottom-32 right-20 text-3xl">🦜</div>
      </div>

      <div className="relative">
        {/* Barra inferior */}
        <div className="border-t border-gray-800">
          <div className="max-w-6xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              {/* Copyright */}
              <div className="text-sm text-gray-400">
                © 2025 Auxiliar Técnico Veterinario. Todos los derechos reservados.
              </div>
              
              {/* Redes sociales */}
              <div className="flex space-x-4">
                <a 
                  href="#" 
                  className="w-8 h-8 border border-gray-600 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-colors"
                >
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a 
                  href="#" 
                  className="w-8 h-8 border border-gray-600 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-colors"
                >
                  <i className="ri-facebook-line text-sm"></i>
                </a>
                <a 
                  href="#" 
                  className="w-8 h-8 border border-gray-600 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-colors"
                >
                  <i className="ri-linkedin-line text-sm"></i>
                </a>
                <a 
                  href="#" 
                  className="w-8 h-8 border border-gray-600 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-colors"
                >
                  <i className="ri-youtube-line text-sm"></i>
                </a>
              </div>
              
              {/* Texto sin enlace */}
              <div className="text-sm text-gray-400">
                Hecho con ❤️ para amantes de los animales
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
